import {
  ArrowTrendingUpIcon,
  ArrowTrendingDownIcon,
} from "@heroicons/react/24/outline";
import { twMerge } from "tailwind-merge";
import { formatPercentage } from "../../../utilities/format";

interface CountCardProps {
  label: string;
  unit?: string;
  count?: number;
  percentage?: number;
  percentageUnit?: string;
  percentageLabel?: string;
}

export default function CountCard({
  label,
  count,
  unit = "",
  percentage,
  percentageUnit = "%",
  percentageLabel = "",
}: CountCardProps) {
  const isNotChanged = percentage === 0;
  const isPositive = !!percentage && percentage > 0;
  const normalizedPercentage = formatPercentage(percentage);

  return (
    <div className="flex h-full w-full flex-col gap-1 rounded-lg border border-zinc-200 bg-gradient-to-br from-zinc-100 via-white to-zinc-100 px-3 py-8">
      <p className="text-sm text-black">{label}</p>
      <p className="text-xl font-bold text-zinc-600">
        {count?.toLocaleString()}
        {unit && unit}
      </p>
      {(!!percentage || percentage === 0) && (
        <div
          className={twMerge(
            "mt-1 flex items-center",
            isPositive ? "text-red-500" : "text-blue-500",
            isNotChanged && "text-zinc-500"
          )}
        >
          {isNotChanged ? (
            <ArrowTrendingUpIcon className="aspect-square h-5 -rotate-[-10deg]" />
          ) : isPositive ? (
            <ArrowTrendingUpIcon className="aspect-square h-5 -rotate-[5deg]" />
          ) : (
            <ArrowTrendingDownIcon className="aspect-square h-5" />
          )}
          <span className="font-bold">
            {normalizedPercentage}
            {percentageUnit}
            {percentageLabel && (
              <span className="text-sm font-normal text-opacity-50">
                {" "}
                {percentageLabel}
              </span>
            )}
          </span>
        </div>
      )}
    </div>
  );
}
